import React from 'react';
import {Control, Errors} from 'react-redux-form';
import {Col, FormControl, FormGroup, Row} from 'react-bootstrap';
import ArrowButton from '../../../common/button-arrow';

const AutoLoadDate = ({index, onDelete}) => (
  <div>

    <Row>
      <Col className="autoload-date-col" lg={12}>
        <FormGroup>
          <Control
            component={FormControl}
            model={`.autoload_dates[${index}]`}
            pattern="\d\d/\d\d"
            placeholder="dd/mm"
          />

          <Errors
            className="errors"
            messages={{
              patternMismatch: 'Value does not match the required pattern'
            }}
            model={`.autoload_dates[${index}]`}
            show={{
              touched: true,
              focus: false
            }}
          />
        </FormGroup>

        <ArrowButton
          arrow={false}
          onClick={() => onDelete(index)}
          submit={false}
        >
          Delete
        </ArrowButton>

      </Col>
    </Row>
  </div>
);

export default AutoLoadDate;



// WEBPACK FOOTER //
// ./src/components/admin/ppc/settings/autoload-date.jsx